import { storageKeys } from '@/app/constants/storageKeys';
import { storage } from '@/app/storage';

export function getIpAddressFromStorage() {
  return storage.get(storageKeys.IP_ADDRESS);
}
